export default [


  {
    path: '/gallery/add',
    name: 'gallery-add',
    component: () => import('@/modules/gallery/add/addGallery.vue'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/gallery/list',
    name: 'gallery-list',
    component: () => import('@/modules/gallery/list/listGallery.vue'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/gallery/edit/:id',
    name: 'gallery-edit',
    component: () => import('@/modules/gallery/edit/editGallery.vue'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/gallery/comments/:id',
    name: 'gallery-comments',
    component: () => import('@/modules/gallery/commentList/galleryCommentList'),

  },
  {
    path: '/gallery/arrange',
    name: 'gallery-arrange',
    component: () => import('@/modules/gallery/Arrage/arrangeGallery'),

  },


]
